import { FC } from 'react';

import './styles.scss';

const Loading: FC = () => {
  return (
    <div className="loading">
      <div className="lds-ripple">
        <div className="icon">
          <img alt="Clik" src={`${process.env.PUBLIC_URL}/images/logo/logo.svg`} />
        </div>
        <div className="rotate"></div>
      </div>
    </div>
  );
};

export default Loading;
